import {
  PatientSwapDefaultTemplateParams,
  PatientSwapEmailPreviewRequest,
  PatientSwapGetPatientsQueryString,
  PatientSwapRemovePatientsRequest,
  PatientSwapSendEmailRequest,
} from "@shared/dtos/requests/patientSwapListRequests.dto"
import {
  PatientSwapUploadProcessRequest,
  PatientSwapUploadRequest,
} from "@shared/dtos/requests/patientSwapUploadRequests.dto"
import { PageResponse } from "@shared/dtos/responses/pageResponse.dto"
import { SwappablePersonWithResults } from "@shared/dtos/responses/patientSwapPatientsResponse.dto"
import {
  PatientSwapAvailablePracticesResponse,
  PatientSwapDefaultTemplateResponse,
  PatientSwapPersonalizedEmailResponse,
  PatientSwapProcessingErrorResponse,
  PatientSwapProcessingResponse,
  PatientSwapTargetPracticesResponse,
} from "@shared/dtos/responses/patientSwapProcessingResponse.dto"
import { Duration } from "@shared/types/duration"
import { PageRequest } from "@shared/zod/schemas/requests/page"
import { PatientSwapFileResponse } from "@shared/zod/schemas/responses/patientSwap"

import { makeAuthGetRequest } from "./utils/makeGetRequest"
import { makeAuthPostRequest } from "./utils/makePostRequest"

// POST request for patient swap
export const upload = makeAuthPostRequest<PatientSwapUploadRequest, PatientSwapFileResponse>("/patient-swap/upload")

export const processUpload = makeAuthPostRequest<
  PatientSwapUploadProcessRequest,
  PatientSwapProcessingResponse | PatientSwapProcessingErrorResponse
>("/patient-swap/upload/process")

export const removePatients = makeAuthPostRequest<PatientSwapRemovePatientsRequest, void>(
  "/patient-swap/remove-patients",

  // IT-3956: Handle large patient CSV files (>5000 patients)
  Duration.from("30 seconds")
)

export const emailPatients = makeAuthPostRequest<PatientSwapSendEmailRequest, void>(
  "/patient-swap/send-email",

  // IT-3956: Handle large patient CSV files being queued up for email
  Duration.from("30 seconds")
)

export const previewEmail = makeAuthPostRequest<PatientSwapEmailPreviewRequest, PatientSwapPersonalizedEmailResponse>(
  "/patient-swap/email-preview"
)

// GET requests for patient swap
export const getPractices = makeAuthGetRequest<void, PatientSwapAvailablePracticesResponse>(
  "/patient-swap/upload/practices"
)
/**
 *  The swap list filters, plus the page of them to read. The list pages with a
 *  cursor, so `offset` and the sort/search fields are deliberately left out.
 */
export type PatientSwapGetPatientsQuery = PatientSwapGetPatientsQueryString & Pick<PageRequest, "limit" | "cursor">

export const getPatients = makeAuthGetRequest<PatientSwapGetPatientsQuery, PageResponse<SwappablePersonWithResults>>(
  "/patient-swap/patients"
)

export const getTargetPractices = makeAuthGetRequest<void, PatientSwapTargetPracticesResponse>(
  "/patient-swap/target-practices"
)

export const getDefaultTemplate = makeAuthGetRequest<
  PatientSwapDefaultTemplateParams,
  PatientSwapDefaultTemplateResponse
>("/patient-swap/default-template")
